import React from 'react';

import Img from '../../Img';
import { LinkAnchor } from '../../Links';

import styles from './highSchoolStandingCard.scss';

const HighSchoolStandingsCard = (props) => {
    const {
        currentClubId,
        clubId,
        clubName,
        clubProfileImages,
        clubLocation,
        rank,
        wins,
        losses,
        leagueWins,
        leagueLosses,
        power6Men,
        power6Women,
        gridLayout,
        showBoysP6,
        showGirlsP6,
        'data-testid': dataTestId,
    } = props;

    const photoUrl = clubProfileImages && clubProfileImages.default ? `/v1/club/${clubProfileImages.default}?variant=icon` : null;
    return (
        <LinkAnchor link={`/schools/${clubId}`} data-testid={dataTestId && `${dataTestId}.card-link`}>
            <div className={`utr-card ${styles.standingsCard}`}>
                <div className={`list-view d-none d-md-block ${currentClubId === clubId ? 'current-club' : ''}`}>
                    <div className={`d-grid w-100`} style={{ gridTemplateColumns: gridLayout.join(' ') }}>
                        <div className={`d-flex aic`}>
                            <div className="values" data-testid={dataTestId && `${dataTestId}.desktop.rank`}>
                                {rank}
                            </div>
                        </div>
                        <div className={`d-flex aic`}>
                            <div className="avatar-wrapper">
                                {photoUrl ? (
                                    <Img
                                        className="avatar"
                                        src={photoUrl}
                                        srcSet={`${photoUrl}&size=1x&type=thumbnail, ${photoUrl}&size=2x&type=thumbnail 2x, ${photoUrl}&size=3x&type=thumbnail 3x`}
                                        defaultimg="/img/v2/icons/icon-avatar-school.svg"
                                    />
                                )
                                    : <Img className="avatar" src="/img/v2/icons/icon-avatar-school.svg" />}
                            </div>
                        </div>
                        <div className={`d-flex aic`}>
                            <div className="values" data-testid={dataTestId && `${dataTestId}.desktop.club-name`}>
                                {clubName}
                                <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.desktop.club-location`}>{clubLocation && clubLocation.display ? clubLocation.display : ''}</div>
                            </div>
                        </div>
                        <div className={`d-flex aic`}>
                            <div className="values w-100 text-center" data-testid={dataTestId && `${dataTestId}.desktop.league-record`}>
                                {leagueWins} - {leagueLosses}
                            </div>
                        </div>
                        <div className={`d-flex aic`}>
                            <div className="values w-100 text-center" data-testid={dataTestId && `${dataTestId}.desktop.overall-record`}>
                                {wins} - {losses}
                            </div>
                        </div>
                        {showBoysP6 && (
                            <div className={`d-flex aic`}>
                                <div className="values w-100 text-center" data-testid={dataTestId && `${dataTestId}.desktop.boys-p6`}>
                                    {power6Men && power6Men > 0 ? power6Men.toFixed(2) : ''}
                                </div>
                            </div>
                        )}
                        {showGirlsP6 && (
                            <div className={`d-flex aic`}>
                                <div className="values w-100 text-center" data-testid={dataTestId && `${dataTestId}.desktop.girls-p6`}>
                                    {power6Women && power6Women > 0 ? power6Women.toFixed(2) : ''}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className={`card-view d-block d-md-none p16 ${currentClubId === clubId ? 'current-club' : ''}`}>
                    <div className="header">
                        <div className="row w-100">
                            <div className="col-1" data-testid={dataTestId && `${dataTestId}.mobile.rank`}>
                                {rank}
                            </div>
                            <div className="col-10">
                                <div className="name-wrapper">
                                    <div className="name university" data-testid={dataTestId && `${dataTestId}.mobile.club-name`}>{clubName}</div>
                                    <div className="place show-ellipsis" data-testid={dataTestId && `${dataTestId}.mobile.club-location`}>{clubLocation && clubLocation.display ? clubLocation.display : ''}</div>
                                </div>
                            </div>
                            <div className="col-1">
                                <div className="profile-pic-wrapper">
                                    {photoUrl ? (
                                        <Img
                                            className="profile-picture"
                                            src={photoUrl}
                                            srcSet={`${photoUrl}&size=1x&type=thumbnail, ${photoUrl}&size=2x&type=thumbnail 2x, ${photoUrl}&size=3x&type=thumbnail 3x`}
                                            defaultimg="/img/v2/icons/icon-avatar-school.svg"
                                        />
                                    )
                                        : <Img className="profile-picture" src="/img/v2/icons/icon-avatar-school.svg" />}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="divider" />
                    <div className="footer">
                        <div className="row">
                            <div className="col-3">
                                <div className="title" data-testid={dataTestId && `${dataTestId}.mobile.league-record-label`}>League<br />Record</div>
                                <div className="value" data-testid={dataTestId && `${dataTestId}.mobile.league-record`}>{leagueWins} - {leagueLosses}</div>
                            </div>
                            <div className="col-3">
                                <div className="title" data-testid={dataTestId && `${dataTestId}.mobile.overall-record-label`}>Overall<br />Record</div>
                                <div className="value" data-testid={dataTestId && `${dataTestId}.mobile.overall-record`}>{wins} - {losses}</div>
                            </div>
                            {showBoysP6 && (
                                <div className="col-3">
                                    <div className="title text-center" data-testid={dataTestId && `${dataTestId}.mobile.boys-p6-label`}>Boys<br />P6</div>
                                    <div className="value" data-testid={dataTestId && `${dataTestId}.mobile.boys-p6`}>{power6Men && power6Men > 0 ? power6Men.toFixed(2) : ''}</div>
                                </div>
                            )}
                            {showGirlsP6 && (
                                <div className="col-3">
                                    <div className="title text-center" data-testid={dataTestId && `${dataTestId}.mobile.girls-p6-label`}>Girls<br />P6</div>
                                    <div className="value" data-testid={dataTestId && `${dataTestId}.mobile.girls-p6`}>{power6Women && power6Women > 0 ? power6Women.toFixed(2) : ''}</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </LinkAnchor>
    );
};

HighSchoolStandingsCard.defaultProps = {
    'data-testid': null,
};

export default HighSchoolStandingsCard;
